import { get } from "lodash";
import log from "loglevel";
import * as t from "./types";

export const getAboutMicroservicesReducerResponse = (
  state: any,
  responseType: string
): t.AboutMicroservice[] => {
  log.info("Getting AboutMicroservices from Store...");
  const value = get(state, `aboutMicroservices.response.${responseType}`);
  return value;
};
